import Lecture from 'components/pages/lecture/lecture/Lecture';

import { dehydrate, QueryClient } from 'react-query';

import { queryClientConfig } from '@core/configs/queryClientConfig';

import { LectureService } from 'services/core';

import { setSsrTokens } from 'utils/authentication';

import { NextSeo } from 'next-seo';
import { getLecturesSeoProps } from 'router/seoprops';

const Lectures = (props) => {
	const seoProps = getLecturesSeoProps({ ...props });
	return (
		<>
			<NextSeo {...seoProps} />
			<Lecture />
		</>
	);
};

export async function getServerSideProps(context) {
	setSsrTokens(context);
	const queryClient = new QueryClient(queryClientConfig);
	const { req } = context;
	const userIp = req.headers['x-forwarded-for'];
	const lectureID = context?.params?.slug[0];
	try {
		const response = await LectureService(lectureID);
		await queryClient.prefetchQuery(['lecture', lectureID], () => ({ data: response.data }));
		let newQueryParams = '';
		const { slug, ...queryParams } = context.query;
		if (queryParams && Object.keys(queryParams).length > 0) {
			newQueryParams = `?${new URLSearchParams(queryParams).toString()}`;
		}
		if (!context?.params?.slug[1]) {
			context.res.setHeader(
				'Location',
				`/courses/${context?.params?.slug[0]}/${response.data.slug}${newQueryParams}`
			);
			context.res.statusCode = 302;
			context.res.end();
		}
		return {
			props: {
				dehydratedState: dehydrate(queryClient),
				id: lectureID,
				title: response.data.title,
				description: response.data.description,
				slug: response.data.slug
			}
		};
	} catch (e) {
		if (e.response.status === 404)
			return {
				redirect: {
					permanent: false,
					destination: "/404"
				}
			}
		else
			return {}
	}
}

export default Lectures;
